import Vue from "vue";
import Permissions from "@/core/services/permissions.service";

Vue.prototype.$can = function(role) {
    const currentUserRoles = Permissions.getPermission();
    return currentUserRoles.includes(role);
}